import { render, staticRenderFns } from "./AdministracionLayout.vue?vue&type=template&id=5e19979e"
import script from "./AdministracionLayout.vue?vue&type=script&lang=ts"
export * from "./AdministracionLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports